<div class="item-list-component prebid-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">
  <dx-popup #prebitOnLotList
            width="98%"
            [showTitle]="true"
            [showCloseButton]="true"
            title="{{ 'PREBID_ON_PRODUCT.TITLE' | translate }}"
            [dragEnabled]="false"
            [closeOnOutsideClick]="false"
            [rtlEnabled]="rtlEnabled"
            [(visible)]="visible">
    <dx-scroll-view width="100%" height="100%">
      <dx-tab-panel [(selectedIndex)]="currentTabIndex" [deferRendering]="false">
        <dxi-item title="{{ 'PREBID_ON_PRODUCT.TAB_REGISTERED' | translate }}" template="PrebidListTab"></dxi-item>
        <dxi-item title="{{ 'PREBID_ON_PRODUCT.TAB_REGISTRATION' | translate }}" template="PrebidPropertiesTab"></dxi-item>
        <div *dxTemplate="let data of 'PrebidPropertiesTab'" class="au-dx-popup-padder">
          <div class="card">
            <div class="card-block">
              <br /><br />
              <dx-form id="buyerPrebidOnProductForm"
                            [(formData)]="model"
                            [items]="prebidOnProductFormItems"
                            colCount="auto"
                            [width]="500"
                            (onFieldDataChanged)="checkIsSecondRestrictionLotPropertyFilled(); checkIfRequiredLotPropertiesFilled();">
                      <div *dxTemplate="let data of 'translatableField'">
                        <translatable-field [isDevExpress]="true" [isLabelHidden]="true" [caption]="''" [(data)]="data.component.option('formData')[data.dataField]" [required]="isRequired(data)"></translatable-field>
                      </div>
                      <div *dxTemplate="let data of 'fullDateTemplate'">
                        <full-date-time-component [data]="dateValue(data)" (modelChanged)="dateChanged(data, $event)" [required]="isRequired(data)"></full-date-time-component>
                      </div>
                      <div *dxTemplate="let data of 'longDateTemplate'">
                        <long-date-component [data]="dateValue(data)" (modelChanged)="dateChanged(data, $event)" [required]="isRequired(data)"></long-date-component>
                      </div>
                      <div *dxTemplate="let data of 'longTimeTemplate'">
                        <long-time-component [data]="dateValue(data)" (modelChanged)="dateChanged(data, $event)" [required]="isRequired(data)"></long-time-component>
                      </div>
                      <div *dxTemplate="let data of 'shortDateTemplate'">
                        <short-date-component [data]="dateValue(data)" (modelChanged)="dateChanged(data, $event)" [required]="isRequired(data)"></short-date-component>
                      </div>
                      <div *dxTemplate="let data of 'shortTimeTemplate'">
                        <short-time-component [data]="dateValue(data)" (modelChanged)="dateChanged(data, $event)" [required]="isRequired(data)"></short-time-component>
                      </div>
                      <div *dxTemplate="let data of 'masterdataTemplate'">
                        <masterdata-dropdown [auctionClusterId]="auctionClusterId"
                                            [listId]="data.name"
                                            [(selectedRowId)]="data.component.option('formData')[data.dataField]"
                                            [filteredKeys]="masterDataDropdownsFiltered[data.name]"
                                            (onValueChanged)="onMasterDataValueChanged($event, data, field)"
                                            [required]="isRequired(data)">
                        </masterdata-dropdown>
                      </div>
              </dx-form>
              <br />
              <label>{{'SHARED.AMOUNT' | translate}}</label>
              <dx-number-box [showSpinButtons]="true"
                            [(value)]="model.amountWanted"
                            [width]="500"
                            format="#0.0"
                            mode="number"
                            [min]="0"
                            [step]="0.1"
                            (onValueChanged)="checkIfRequiredLotPropertiesFilled();">
              </dx-number-box>
              <div *ngIf="!model.allOrNothing">
                <br />
                <label>{{'PREBID_ON_PRODUCT.MIN_AMOUNT' | translate}}</label>
                <dx-number-box [showSpinButtons]="true"
                              [(value)]="model.minAmount"
                              [width]="500"
                              format="#0.0"
                              mode="number"
                              [min]="0"
                              [max]="model.amountWanted"
                              [step]="0.1"
                              (onValueChanged)="checkIfRequiredLotPropertiesFilled();">
                </dx-number-box>
              </div>
              <br />
              <label>{{'PREBID_ON_PRODUCT.MAX_AMOUNT' | translate}}</label>
              <dx-number-box [showSpinButtons]="true"
                            [(value)]="model.maxAmount"
                            [width]="500"
                            format="#0.0"
                            mode="number"
                            [min]="model.amountWanted"
                            [step]="0.1"
                            (onValueChanged)="checkIfRequiredLotPropertiesFilled();">
              </dx-number-box>
              <br />
              <label>{{'SHARED.PRICE' | translate}}</label>
              <dx-number-box [showSpinButtons]="true"
                            [(value)]="model.price"
                            [width]="500"
                            format="#0.0"
                            mode="number"
                            [min]="0"
                            [step]="0.1"
                            (onValueChanged)="checkIfRequiredLotPropertiesFilled();">
              </dx-number-box>
              <br />
              <label>{{'SHARED.PREBID_SUBBUYER' | translate}}</label>
              <dx-select-box [dataSource]="subbuyerDataSource"
                            [(value)]="selectedSubbuyer"
                            searchTimeout="200"
                            displayExpr="displayValue"
                            searchMode="Contains"
                            [searchEnabled]="true"
                            [showClearButton]="true"
                            [width]="500"
                            placeholder="{{ 'SHARED.SELECT' | translate }} ..."
                            class="filter-lot-select focusable">
                <div *dxTemplate="let data of 'item'">
                    <div>
                        {{ data.displayValue }}
                    </div>
                  </div>
              </dx-select-box>
              <br />
              <dx-check-box [(value)]="model.allOrNothing" text="{{'SUPPLY_MONITOR.ALL_OR_NOTHING' | translate}}"></dx-check-box>
              <br/><br />
            </div>
          </div>

          <div class="grid-buttons">
            <button [disabled]="!secondRestrictionLotPropertyFilled || !requiredPrebidOnProductPropertiesFilled" type="button" class="btn btn-primary" (click)="save();">{{ 'SHARED.SAVE' | translate }}</button>
            <dx-button hint="{{ 'SHARED.ADD' | translate }}"
                      icon="add"
                      (onClick)="initModelOnNew()"></dx-button>
          </div>
        </div>

        <div *dxTemplate="let data of 'PrebidListTab'" class="au-dx-popup-padder">
          <dx-data-grid id="printSection"
                        [rtlEnabled]="rtlEnabled"
                        [showBorders]="true"
                        (onInitialized)="initColumn($event)"
                        [allowColumnReordering]="true"
                        [hoverStateEnabled]="true"
                        [columnAutoWidth]="true"
                        [rowAlternationEnabled]="true"
                        [(dataSource)]="dataGridItems"
                        [columns]="dataGridColumns">
            <dxo-selection mode="single"></dxo-selection>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true"></dxo-search-panel>
            <dxo-pager [visible]="true"
                      [showPageSizeSelector]="true"
                      [allowedPageSizes]="[5, 10, 20, 30, 40, 50, 100, 200]"
                      [showNavigationButtons]="true"
                      [showInfo]="true"
                      infoText="{2} {{ 'PREBID_ON_PRODUCT.PAGINATION_TEXT_PLACEHOLDER' | translate | slice:2 }}"></dxo-pager>
            <!--<dxi-column [width]="120" cellTemplate='checkBoxTemplate' caption="{{'SUPPLY_MONITOR.ALL_OR_NOTHING' | translate}}">
            </dxi-column>-->
            <div *dxTemplate="let d of 'checkBoxTemplate'">
              <dx-check-box [value]="d.data.__item__.allOrNothing" [readOnly]="true"></dx-check-box>
            </div>
            <!--<dxi-column type="buttons" [width]="120" cellTemplate='buttonsTemplate'>
            </dxi-column>-->
            <div *dxTemplate="let d of 'buttonsTemplate'">
              <a (click)="edit(d.data.__item__.prebidOnProductId, $event)" class="dx-link"><i title="{{ 'SHARED.EDIT' | translate }}" class="dx-icon-edit"></i></a>
              <a (click)="delete(d.data.__item__.prebidOnProductId, $event)" class="dx-link"><i title="{{ 'SHARED.DELETE' | translate }}" class="dx-icon-trash"></i></a>
            </div>
          </dx-data-grid>
        </div>
      </dx-tab-panel>
      <div class="grid-buttons au-dx-popup-padder">
        <button type="button" class="btn btn-primary" (click)="close();">{{ 'SHARED.CLOSE' | translate }}</button>
      </div>
      <br/>
    </dx-scroll-view>
  </dx-popup>
</div>
<confirmation-component #confirmation title="{{ 'PREBID_ON_PRODUCT.DELETE_PREBID_ON_PRODUCT_LOT' | translate }}"
                        message="{{ 'PREBID_ON_PRODUCT.DELETE_PREBID_ON_PRODUCT_LOT_MESSAGE' | translate }}"
                        buttonCloseText="{{ 'SHARED.DELETE' | translate }}" cancellable="true" (close)="deleteSelected();"></confirmation-component>
